import React, { useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AddCircleBlue, FullTable } from 'components';
import { FindSuccessItem, sortListByKey, useModal } from 'utils';
import { httpRequestsOnSuccessActions, systemActions } from 'store';
import { BANK_ACTION_TYPE, banksBody, banksHead, banksNotYet } from './constants';
import { AddBank } from './addBank';

const CREATE_ACTION_TYPE = 'CREATE_BANK';
const EDIT_ACTION_TYPE = 'EDIT_BANK';

export const Banks = ({}) => {
    const { open, close } = useModal();
    const dispatch = useDispatch();
    const bankList = useSelector((state) => state.system.bankList);
    const createSuccess = FindSuccessItem(CREATE_ACTION_TYPE);
    const editSuccess = FindSuccessItem(EDIT_ACTION_TYPE);
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;

    useEffect(() => {
        if (createSuccess || editSuccess) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(CREATE_ACTION_TYPE));
            dispatch(httpRequestsOnSuccessActions.removeSuccess(EDIT_ACTION_TYPE));
            getBanks('noLoad');
            close();
        }
    }, [createSuccess, editSuccess]);

    useEffect(() => {
        getBanks();
    }, [info]);

    const getBanks = (load) => {
        const sendParams = {
            ...info,
        };
        delete sendParams.activeTab;
        dispatch(systemActions.getBanks(sendParams, load));
    };

    const handleEdit = (item, name) => {
        if (name === 'edit') {
            open(<AddBank info={item} />);
        }
        // if (name === 'delete') {
        //     open(
        //         <CustomDelete
        //             info="Inactivate Payer"
        //             text="Are you sure you want to inactivate this payer ?"
        //             handleDel={() => dispatch(clientActions.terminateClientEnrollment(client?.id, item?.id, item))}
        //             actionType={TERMINATE_CLIENT_ENROLLMENT}
        //             innerText={'Inactivate'}
        //             afterSuccess={() => getEnrollments('noLoad')}
        //         />,
        //     );
        // }
    };

    return (
        <div>
            <div className="header-action-btn">
                <AddCircleBlue text={'Add Bank'} handleClick={() => open(<AddBank />)} />
            </div>
            <FullTable
                head={banksHead}
                body={banksBody}
                loadingType={BANK_ACTION_TYPE}
                list={sortListByKey(bankList, 'name') || []}
                handleClickButton={handleEdit}
                notYet={banksNotYet}
                margin={'0'}
            />
        </div>
    );
};
